module.exports = __webpack_public_path__ + "d46b65178400530b8a95d848a186a643.svg";